import { useTranslation } from 'react-i18next';
import { testimonials } from '../../../mocks/testimonials';

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section id="testimonios" className="relative py-16 md:py-32 px-4 md:px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cd895a66daa3b92b16e242a78299c753.jpg"
          alt="Chilean Landscape"
          className="w-full h-full object-cover object-center fixed"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-8 md:mb-16">
          {t('test_title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 hover:bg-white transition-all duration-300"
            >
              <i className="ri-double-quotes-l text-4xl md:text-5xl text-teal-600 mb-4"></i>

              <p className="text-gray-700 text-base md:text-lg italic leading-relaxed mb-6">
                {testimonial.text}
              </p>

              <div className="h-px bg-gray-200 mb-6"></div>

              <div className="flex items-center gap-4">
                <div className="relative">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                </div>

                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <div className="flex items-center gap-1 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm ${
                          i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}